import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PracticeInfo from '../PracticeChange/PracticeInfo';

class SettingsSidebar extends Component {
  state = {
    activeLayout: 'Practice Info',
  };

  render() {
    return (
      <Container fluid>
        <Row>
          <Col sm={'12'} md={'12'}>
            <p>{this.state.activeLayout}</p>
            <div style={{ backgroundColor: '#fff', minHeight: '80vh', padding: 20 }}>
              <PracticeInfo />
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SettingsSidebar;
